// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8I4he","left":"styles_left__3FEJn"};